import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';

import { CopyToClipboardComponent } from '@ux/components/copy-to-clipboard/copy-to-clipboard.component';
import { IconDsComponent } from '@design-system/components/atoms/icon/icon.component';
import { TooltipModule } from '@shared/tooltip/tooltip.module';
import { TooltipDsComponent } from '@design-system/components/templates/tooltip/tooltip.component';

@NgModule({
  declarations: [
    CopyToClipboardComponent
  ],
  exports: [
    CopyToClipboardComponent
  ],
  imports: [
    CommonModule,
    TranslocoModule,
    TooltipModule,
    TooltipDsComponent,
    IconDsComponent,
  ]
})
export class CopyToClipboardModule { }
